import { render, staticRenderFns } from "./CompanyAccessPanel.vue?vue&type=template&id=6d04813e&scoped=true"
import script from "./CompanyAccessPanel.vue?vue&type=script&lang=js"
export * from "./CompanyAccessPanel.vue?vue&type=script&lang=js"
import style0 from "./CompanyAccessPanel.vue?vue&type=style&index=0&id=6d04813e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d04813e",
  null
  
)

export default component.exports